<script>
  import SourceGroupCard from 'components/SourceGroupCard/SourceGroupCard.vue';
import options from './SourceOverlay.options'
import SourceExternalLinks from 'components/SourceExternalLinks/SourceExternalLinks.vue';
import SourceReferences from 'components/SourceReferences/SourceReferences.vue';
  export default options
</script>

<template>

  <div class="kb-overlay-styles__content-wrapper">
    <article class="kb-overlay-styles kb-source-overlay">
      <div class="kb-overlay-styles__wrapper-for-scroll-bottom">

        <section class="kb-source-overlay__hero">
          <h1 class="kb-source-overlay__hero-title">
            {{ source.name }}
          </h1>

          <div class="kb-source-overlay__breaker">
            <svg viewBox="0 0 81 11" fill="none" xmlns="http://www.w3.org/2000/svg" ><path d="M2 .5h79v1H2v-1ZM1.5 2v9h-1V2h1Zm.5-.5a.5.5 0 0 0-.5.5h-1A1.5 1.5 0 0 1 2 .5v1Z" /></svg>
          </div>
          
          <div class="kb-source-overlay__description">
            <p class="kb-source-overlay__description-text">{{ source.title }}</p>
            <p class="kb-source-overlay__description-text">{{ source.workPlace }}</p>
          </div>
        </section>

        <div class="kb-overlay-styles__hero-curve">
          <svg role="presentation" viewBox="0 0 720 77" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 0V42.4078C238.547 71.2459 479.584 82.0555 720 74.8278V0H0Z" />
          </svg>
        </div>

        <div class="kb-source-overlay__content">
          
          <template v-if="source.group">
            <SourceGroupCard
              :name="source.name"
              :title="source.group.title"
              :text="source.group.description"
              :linkUrl="source.group.linkUrl"
              :linkText="source.group.linkText"
            />
          </template>
  
          <SourceExternalLinks
            :name="source.name"
            :links="source.externalLinks"
          />
  
          <SourceReferences
            :sourceId="source.id"
          />

        </div>

      </div>
    </article>
  </div>

</template>
